module.exports = __webpack_public_path__ + "img/addxnwl.7cc00ad4.png";